/**
 * Shared visual constants for the BerlinMap widget. Kept here (rather than
 * inline in components) so the page-level CTA cards / external embeds can
 * import the same hex codes when matching styles.
 */
export const CLOSED_COLOR = "#005279";
export const OPEN_COLOR = "#EA565A";

/**
 * How dots are coloured.
 * - "status" (default): blue when an address has mostly closed cases, red
 *   when mostly open.
 * - "won": every dot in the wins blue — for marketing embeds showcasing
 *   successes, where red reads as negative.
 */
export type MapColorMode = "status" | "won";

/**
 * How the points are laid out on the map.
 * - "cluster" (default): nearby buildings collapse into count bubbles at low
 *   zoom, expanding to individual dots as you zoom in.
 * - "dots": every building as its own dot, no grouping (set via
 *   `data-cluster="off"`).
 */
export type MapDisplayMode = "cluster" | "dots";

/** Diameter (px) of a marker representing a single open case with €0 saved. */
export const MIN_RADIUS = 3;
/** Diameter (px) cap for the largest marker we'll draw. */
export const MAX_RADIUS = 14;
